import { ActionContext, ActionTree, MutationTree, Module as VuexModuleInterface } from 'vuex'
import Cookies from 'js-cookie'
import { RootState } from '@/store'
import cookies from '@/cookies'

export enum DeviceType {
  Mobile,
  Desktop
}

export type SidebarType = {
  opened: boolean
  withoutAnimation: boolean
}

export interface LayoutState {
  device: DeviceType
  sidebar: SidebarType
  isLayoutVisible: boolean
  isGoodbyeVisible: boolean
}

export const LayoutMutationTypes = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
  TOGGLE_DEVICE: 'TOGGLE_DEVICE',
  TOGGLE_LAYOUT: 'TOGGLE_LAYOUT',
  SHOW_LAYOUT: 'SHOW_LAYOUT',
  HIDE_LAYOUT: 'HIDE_LAYOUT',
  SHOW_GOODBYE: 'SHOW_GOODBYE'
}

const state = (): LayoutState => {
  return {
    device: DeviceType.Desktop,
    sidebar: {
      opened: Cookies.get(cookies.SIDEBAR_STATUS) !== 'closed',
      withoutAnimation: false
    },
    isLayoutVisible: true,
    isGoodbyeVisible: false
  }
}

const mutations: MutationTree<LayoutState> = {
  [LayoutMutationTypes.TOGGLE_SIDEBAR](state, withoutAnimation: boolean) {
    Cookies.set(cookies.SIDEBAR_STATUS, state.sidebar.opened ? 'closed' : 'opened')

    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = withoutAnimation
  },
  [LayoutMutationTypes.CLOSE_SIDEBAR](state, withoutAnimation: boolean) {
    Cookies.set(cookies.SIDEBAR_STATUS, 'closed')

    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  [LayoutMutationTypes.TOGGLE_DEVICE](state, device: DeviceType) {
    state.device = device
  },
  [LayoutMutationTypes.TOGGLE_LAYOUT](state) {
    state.isLayoutVisible = !state.isLayoutVisible
  },
  [LayoutMutationTypes.SHOW_LAYOUT](state) {
    state.isLayoutVisible = true
  },
  [LayoutMutationTypes.HIDE_LAYOUT](state) {
    state.isLayoutVisible = false
  },
  [LayoutMutationTypes.SHOW_GOODBYE](state) {
    state.isGoodbyeVisible = true
  }
}

interface Actions<S, R> extends ActionTree<S, R> {
  toggleSidebar(context: ActionContext<S, R>, withoutAnimation: boolean): void

  closeSidebar(context: ActionContext<S, R>, withoutAnimation: boolean): void

  toggleDevice(context: ActionContext<S, R>, device: DeviceType): void
}

const actions: Actions<LayoutState, RootState> = {
  toggleSidebar({ commit }, withoutAnimation: boolean) {
    commit(LayoutMutationTypes.TOGGLE_SIDEBAR, withoutAnimation)
  },
  closeSidebar({ commit }, withoutAnimation: boolean) {
    commit(LayoutMutationTypes.CLOSE_SIDEBAR, withoutAnimation)
  },
  toggleDevice({ commit }, device: DeviceType) {
    commit(LayoutMutationTypes.TOGGLE_DEVICE, device)
  }
}

const module: VuexModuleInterface<LayoutState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default module
